// The date of a device sale — migration 0058. Replaces the start/end/duration
// triad on a time entry that sells a drive: a sale is dated, not timed, and the
// API refuses hours or a span on one (assertSaleShape).

import { DateInput } from './DateInput';

/** Local midnight of `epochMs` — a sale date carries no time of day. */
export function startOfLocalDay(epochMs: number): number {
  const d = new Date(epochMs);
  d.setHours(0, 0, 0, 0);
  return d.getTime();
}

export interface SaleDateFieldProps {
  value: number | null;
  onChange: (epochMs: number | null) => void;
  disabled?: boolean;
  error?: string;
  /** Wrapper class, so each host form keeps its own field styling. */
  className?: string;
  id?: string;
}

export function SaleDateField(props: SaleDateFieldProps): JSX.Element {
  const { value, onChange, disabled = false, error, className, id = 'sale-date' } = props;
  return (
    <label className={className}>
      <span>Sale date *</span>
      <DateInput
        id={id}
        value={value}
        onChange={(v) => onChange(v === null ? null : startOfLocalDay(v))}
        disabled={disabled}
        required
      />
      {error && <span className="field-error">{error}</span>}
    </label>
  );
}
